import React, { useState, useEffect } from "react";
import { Table, message, Card, Avatar, Typography, Tag } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";

import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const LearnersList = () => {
  const [learners, setLearners] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchLearners = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Learners/GetListAll`, {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch learners");
      }

      const data = await response.json();
      setLearners(data);
    } catch (error) {
      console.error("Error fetching learners:", error);
      message.error("Failed to load learners data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLearners();
  }, []);

  const columns = [
    {
      title: "Learner",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={`${baseImageUrl}${record.profileImage}`}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#f56a00",
            }}
          />
          <Text strong>
            {record.firstName} {record.lastName}
          </Text>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Business Group",
      dataIndex: "businessGroupName",
      key: "businessGroupName",
      render: (text, record) => (record.hasBusinessGroup ? text : "N/A"),
    },
    {
      title: "Manager Assigned",
      dataIndex: "isManagerAssigned",
      key: "isManagerAssigned",
      render: (text, record) => (
        <Tag color={record.isManagerAssigned ? "green" : "red"}>
          {record.isManagerAssigned ? "Manager Assigned" : "Not Assigned"}
        </Tag>
      ),
    },
    {
      title: "Manager Name",
      dataIndex: "managerName",
      key: "managerName",
      render: (text) => (text ? text : "N/A"),
    },
  ];

  return (
    <Card className="card-professional" title="Learners List" bordered={false}>
      <Table
        columns={columns}
        dataSource={learners}
        rowKey="learnerId"
        loading={loading}
        pagination={true}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default LearnersList;
